import { render, staticRenderFns } from "./tableModal.vue?vue&type=template&id=6707e39c&"
import script from "./tableModal.vue?vue&type=script&lang=js&"
export * from "./tableModal.vue?vue&type=script&lang=js&"
import style0 from "./tableModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports